import React from 'react'
import { ImageComp } from '../../../Components/ImageCompo/ImageComp'
import ButtonComp from '../../../Components/ButtonComp/ButtonComp'
import { useNavigate } from 'react-router-dom'
const Header = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className='flex px-[30px] shadow- justify-between py-[20px]'>
        <div>
          <ImageComp className='h-[40px] overflow-hidden object-cover' source='./Images/logo.png' />
        </div>
        <div>
          <ButtonComp onClick={() => { navigate('/loginDataUser') }} className='px-[30px] py-[5px] rounded-full bg-[#004878] text-[white] border-none' text='Login/Register' />
        </div>
      </div>
    </>
  )
}

export default Header